import { Http, Headers, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { webConfig } from './webConfig';
import * as FileSaver from 'file-saver';
import { Helpers } from './helpers';

@Injectable()
export class AppService {
    constructor(private http: Http, private _router: Router, private config: webConfig) { }

    public url = this.config.url;


    public download() {
        this.http.get(`${this.url}`+'api/finance/download_excel', this._headerblob())
            .map(res => res.blob())
            .subscribe(
                data => {
                    const filename = 'Financial Management'+Date.now()+'.xlsx'
                    FileSaver.saveAs(data, filename);
                    Helpers.setLoading(false);
                },
                err => {
                    console.log('error');
                    console.error(err);
                    Helpers.setLoading(false);
                });

    }



    public get(_apiUrl, params?): Observable<any> {
        return this.http.get(`${this.url}` + _apiUrl, new RequestOptions({
            headers: this._header(),
            params
        }))
            .map(this.extractData)
            .catch(this.handleError);
    }

    public post(_apiUrl, item: any): Observable<any> {
        return this.http.post(`${this.url}` + _apiUrl, item, new RequestOptions({ headers: this._header() }))
            .map(this.extractData)
            .catch(this.handleError);
    }

    public put(_apiUrl, itemId: number, item: any): Observable<any> {
        return this.http.put(`${this.url}` + _apiUrl + itemId, item, new RequestOptions({ headers: this._header() }))
            .map(this.extractData)
            .catch(this.handleError);
    }
    public patch(_apiUrl, item: any): Observable<any> {
        return this.http.patch(`${this.url}` + _apiUrl, item, new RequestOptions({ headers: this._header() }))
            .map(this.extractData)
            .catch(this.handleError);
    }

    public delete(_apiUrl, item: any): Observable<any> {
        return this.http.delete(`${this.url}` + _apiUrl + item, new RequestOptions({ headers: this._header() }))
            .map(this.extractData
            )
            .catch(this.handleError);
    }


    _header() {
        let user = localStorage.getItem('currentUser');
        if (!!user) {
            let temp = JSON.parse(user)
            let token = temp['token'];
            return new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'jwt ' + token });
        }
    }

    _headerblob() {
        let user = localStorage.getItem('currentUser');
        if (!!user) {
            let temp = JSON.parse(user)
            let token = temp['token'];
            const headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'jwt ' + token });
            const options = new RequestOptions({ headers: headers });
            options.responseType = ResponseContentType.Blob;
            return options;
        }
    }


    public extractData(res: Response) {
        let body = res.json();
        return body;
    }
    public handleError(error: Response | any) {
        return Observable.throw(error);
    }


}





// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/app.service.ts